import { createSlice } from '@reduxjs/toolkit';

import { SigningDocument } from '@/types/document';

import { fetchSigningDocuments } from './actions';

export interface DocumentSigningState {
  signingDocs: SigningDocument[];
  hashSigningDocsByCode: Record<string, SigningDocument>;
  isLoading: boolean;
  error?: string;
}

export const INITIAL_DOCUMENT_SIGNING_STATE: DocumentSigningState = {
  signingDocs: [],
  hashSigningDocsByCode: {},
  isLoading: false,
  error: undefined,
};

export const documentSigningSlice = createSlice({
  name: 'document-signing',
  initialState: INITIAL_DOCUMENT_SIGNING_STATE,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchSigningDocuments.fulfilled, (state, { payload }) => {
      state.signingDocs = payload;
      state.hashSigningDocsByCode = payload.reduce(
        (acc, doc) => {
          acc[doc.code] = doc;
          return acc;
        },
        {} as Record<string, SigningDocument>,
      );
      state.isLoading = false;
      state.error = undefined;
    });
    builder.addCase(fetchSigningDocuments.pending, state => {
      state.isLoading = true;
      state.error = undefined;
    });
    builder.addCase(fetchSigningDocuments.rejected, (state, { error }) => {
      state.isLoading = false;
      state.error = error.message;
    });
  },
});

export const documentSigningReducer = documentSigningSlice.reducer;
